import React, { useEffect, useState } from "react";
import {
  CustomOutlinedDisabledCurrencyField,
  CustomOutlinedDisabledTextField,
} from "../../../../../partials/content/Forms";
import { formatDate } from "../../../../../utils/utils";
import { Typography } from "@material-ui/core";
import { getPurchaseRequestDetail } from "../../../../../services/inventory/procurementService";
import { getDocumentApprovalProcess } from "../../../../../services/usersService";
import NumberFormat from "react-number-format";
import { Card, Badge } from "react-bootstrap";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Table } from "react-bootstrap";
import Illustration from "../../../../../partials/content/Illustration";
import parse from "html-react-parser";
import { Timeline } from "primereact/timeline";
import { Step, StepLabel, Stepper } from "@material-ui/core";
import { TabPanel, TabView } from "primereact/tabview";
import Attachments from "../../../common/attachments";
import Notes from "../../../common/notes";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
function PrBasicInfo({
  purchaseRequestID = 0,
  approvalProcessImp = [],
  approvalStepsImp = [],
  approvalActiveStepImp = 0,
}) {
  const [purchaseRequest, setPurchaseRequest] = useState({
    ID: 0,
    approvalProcessID: 0,
    warehouseID: 0,
    warehouseName: "",
    currencyID: 0,
    currencyCode: "",
    statusID: 0,
    statusName: "",
    valPrice: 0,
    note: "",
    approvalStatusDesc: "",
    purchaseRequests: [],
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [approvalProcess, setApprovalProcess] = useState(approvalProcessImp);
  const [approvalSteps, setApprovalSteps] = useState(approvalStepsImp);
  const [approvalActiveStep, setApprovalActiveStep] = useState(
    approvalActiveStepImp
  );
  const [canBeEdit, setCanBeEdit] = useState(false);
  useEffect(() => {
    if (purchaseRequestID > 0) {
      getPurchaseRequestDetailData(purchaseRequestID);
      getApprovalProcessData(purchaseRequestID);
    }
  }, [purchaseRequestID]);
  return (
    <React.Fragment>
      <div className="tabview mb-3">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Basic Info" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Purchase Request Header</strong>
                      </span>
                      <Badge
                        className="float-right ml-1"
                        variant={
                          purchaseRequest.statusID === 1
                            ? "danger"
                            : purchaseRequest.statusID === 2
                            ? "warning"
                            : purchaseRequest.statusID === 3
                            ? "success"
                            : purchaseRequest.statusID === 4
                            ? "warning"
                            : purchaseRequest.statusID === 5
                            ? "success"
                            : purchaseRequest.statusID === 9
                            ? "danger"
                            : null
                        }
                      >
                        {purchaseRequest.statusID !== 0
                          ? "Purchase Request " + purchaseRequest.statusName
                          : null}
                      </Badge>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Purchase Request ID"
                            value={purchaseRequest.ID}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Warehouse Name"
                            value={purchaseRequest.warehouseName}
                          />
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Currency"
                                value={purchaseRequest.currencyCode}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledCurrencyField
                                label="Valuation Price"
                                value={purchaseRequest.valPrice}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Request Date"
                                value={formatDate(purchaseRequest.requestDate)}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Expected Fulfillment Date"
                                value={formatDate(
                                  purchaseRequest.expFulfillmentDate
                                )}
                              />
                            </div>
                          </div>
                          <CustomOutlinedDisabledTextField
                            label="Note"
                            value={purchaseRequest.note}
                            multiline
                            minRows={4}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Approval Status"
                            value={purchaseRequest.approvalStatusDesc}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Attachments" rightIcon="fas fa-paperclip">
              <Attachments docType="PORQ" docID={purchaseRequestID} />
            </TabPanel>
            <TabPanel header="Notes" rightIcon="fas fa-sticky-note">
              <Notes docType="PORQ" docID={purchaseRequestID} />
            </TabPanel>
            {approvalProcess.length ? (
              <TabPanel
                header="Approval Flow"
                rightIcon="fas fa-file-signature"
              >
                {approvalSteps.length ? (
                  <Stepper activeStep={approvalActiveStep} alternativeLabel>
                    <Step>
                      <StepLabel
                        optional={
                          <Typography align="center" variant="body2">
                            INITIATED
                          </Typography>
                        }
                      >
                        Document Approval
                      </StepLabel>
                    </Step>
                    {approvalSteps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      if (label.level < purchaseRequest.approvalProcess.level)
                        labelProps.optional = (
                          <Typography
                            align="center"
                            variant="body2"
                            className="text-success"
                          >
                            APPROVED
                          </Typography>
                        );
                      if (
                        label.approvalID ===
                          purchaseRequest.approvalProcess.approvalID &&
                        label.level === purchaseRequest.approvalProcess.level
                      ) {
                        if (purchaseRequest.approvalProcess.statusID === 1) {
                          labelProps.error = false;
                          labelProps.optional = (
                            <Typography align="center" variant="body2">
                              IN REVIEW
                            </Typography>
                          );
                        } else if (
                          purchaseRequest.approvalProcess.statusID === 2
                        ) {
                          labelProps.error = false;
                          stepProps.completed = true;
                          labelProps.optional = (
                            <Typography
                              align="center"
                              variant="body2"
                              className="text-success"
                            >
                              APPROVED
                            </Typography>
                          );
                        } else if (
                          purchaseRequest.approvalProcess.statusID === 3
                        ) {
                          labelProps.error = true;
                          labelProps.optional = (
                            <Typography
                              align="center"
                              variant="body2"
                              className="text-danger"
                            >
                              REJECTED
                            </Typography>
                          );
                        }
                      }
                      return (
                        <Step key={index} {...stepProps}>
                          <StepLabel {...labelProps}>
                            {label.userGroup.groupName}
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                ) : null}
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Card>
                      <Card.Header>
                        <i className="fas fa-history"></i>
                        <span>
                          <strong>Approval Flow History</strong>
                        </span>
                      </Card.Header>
                      <Card.Body>
                        <Timeline
                          value={approvalProcess}
                          opposite={(item) => {
                            return (
                              <div>
                                {item.statusDesc}
                                {item.statusID === 2 || item.statusID === 3 ? (
                                  <React.Fragment>
                                    <br />
                                    <strong>Note :</strong>
                                    <br />
                                    {parse(item.note)}
                                  </React.Fragment>
                                ) : null}
                              </div>
                            );
                          }}
                          content={(item) => {
                            return (
                              <small className="text-muted">
                                {formatDate(item.actionDate, true)}
                              </small>
                            );
                          }}
                          marker={(item) => {
                            if (item.statusID === 0) {
                              return (
                                <span className="custom-timeline-marker bg-info">
                                  <i className="fas fa-play-circle"></i>
                                </span>
                              );
                            } else if (item.statusID === 1) {
                              return (
                                <span className="custom-timeline-marker bg-warning">
                                  <i className="fas fa-clock"></i>
                                </span>
                              );
                            } else if (item.statusID === 2) {
                              return (
                                <span className="custom-timeline-marker bg-success">
                                  <i className="fas fa-check-circle"></i>
                                </span>
                              );
                            } else if (item.statusID === 3) {
                              return (
                                <span className="custom-timeline-marker bg-danger">
                                  <i className="fas fa-times-circle"></i>
                                </span>
                              );
                            } else {
                              return (
                                <span className="custom-timeline-marker bg-dark">
                                  <i className="fas fa-question-circle"></i>
                                </span>
                              );
                            }
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </TabPanel>
            ) : (
              <TabPanel
                header="Approval Flow"
                rightIcon="fas fa-file-signature"
                disabled
              ></TabPanel>
            )}
          </TabView>
        </div>
      </div>
      <div className="accordion">
        <div className="card">
          <Accordion
            className="accordion"
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <AccordionTab
              header={
                <React.Fragment>
                  <i className="fas fa-sitemap"></i>
                  <span>
                    <strong>Purchase Request Items</strong>
                  </span>
                </React.Fragment>
              }
            >
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="card">
                        <Table striped borderless size="sm" responsive="xl">
                          {purchaseRequest.purchaseRequests &&
                          purchaseRequest.purchaseRequests.length > 0 ? (
                            <thead>
                              <tr>
                                <th style={{ width: "5%" }}>
                                  <Typography className="mx-1 kt-font-bolder">
                                    Request Status
                                  </Typography>
                                </th>
                                <th style={{ width: "25%" }}>
                                  <Typography className="mx-1 kt-font-bolder">
                                    Item Name
                                  </Typography>
                                </th>
                                <th style={{ width: "10%" }}>
                                  <Typography className="mx-1 kt-font-bolder">
                                    Purchase Order ID
                                  </Typography>
                                </th>
                                <th style={{ width: "15%" }}>
                                  <Typography className="mx-1 kt-font-bolder">
                                    Vendor Name
                                  </Typography>
                                </th>
                                <th style={{ width: "5%" }}>
                                  <Typography className="mx-1 kt-font-bolder">
                                    Quantity
                                  </Typography>
                                </th>
                                <th style={{ width: "10%" }}>
                                  <Typography className="mx-1 kt-font-bolder">
                                    Unit
                                  </Typography>
                                </th>
                                <th style={{ width: "15%" }}>
                                  <Typography className="mx-1 kt-font-bolder text-right">
                                    Valuation Unit Price
                                  </Typography>
                                </th>
                                <th style={{ width: "15%" }}>
                                  <Typography className="mx-1 kt-font-bolder text-right">
                                    Valuation Total Price
                                  </Typography>
                                </th>
                              </tr>
                            </thead>
                          ) : null}
                          <tbody>
                            {purchaseRequest.purchaseRequests &&
                            purchaseRequest.purchaseRequests.length > 0 ? (
                              purchaseRequest.purchaseRequests.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <Typography align="center">
                                        <Badge
                                          className="mx-1 my-1"
                                          variant={
                                            item.statusID === 1
                                              ? "danger"
                                              : item.statusID === 2
                                              ? "warning"
                                              : item.statusID === 3
                                              ? "success"
                                              : item.statusID === 4
                                              ? "warning"
                                              : item.statusID === 5
                                              ? "success"
                                              : item.statusID === 9
                                              ? "danger"
                                              : null
                                          }
                                        >
                                          {item.statusID !== 0
                                            ? item.statusName
                                            : null}
                                        </Badge>
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.itemType > 0 ? (
                                          <span>
                                            <BootstrapTooltip
                                              title={item.itemTypeName}
                                            >
                                              <span className="mr-2">
                                                <i
                                                  className={
                                                    item.itemType === 1
                                                      ? "fas fa-boxes text-success"
                                                      : item.itemType === 2
                                                      ? "fas fa-tools text-primary"
                                                      : item.itemType === 3
                                                      ? "fas fa-building text-info"
                                                      : item.itemType === 4
                                                      ? "fas fa-boxes text-warning"
                                                      : item.itemType === 5
                                                      ? "fas fa-boxes text-danger"
                                                      : null
                                                  }
                                                ></i>
                                              </span>
                                            </BootstrapTooltip>
                                            <span>
                                              {item.itemCode} {item.itemName}
                                            </span>
                                          </span>
                                        ) : (
                                          <React.Fragment>
                                            {item.itemCode} {item.itemName}
                                          </React.Fragment>
                                        )}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.poCode}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.vendorName}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.qty}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.uomName}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography
                                        component="div"
                                        className="mx-1 my-1"
                                      >
                                        <NumberFormat
                                          value={item.unitValPrice}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {purchaseRequest.currencyCode}{" "}
                                              {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography
                                        component="div"
                                        className="mx-1 my-1"
                                      >
                                        <NumberFormat
                                          value={item.totalValPrice}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {purchaseRequest.currencyCode}{" "}
                                              {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td className="text-center py-3" colSpan="8">
                                  <Illustration
                                    imageSource="INVIFO Procurement.png"
                                    guidance="You don't have any Purchase Request items yet"
                                    guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                    size="sm"
                                  ></Illustration>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
    </React.Fragment>
  );

  async function getPurchaseRequestDetailData(purchaseRequestID = 0) {
    const response = await getPurchaseRequestDetail(purchaseRequestID);
    const { data } = response.data;
    setPurchaseRequest(data.purchaseRequest);
    setApprovalSteps(
      data.purchaseRequest.approvalProcess.approval.approvalValue
    );
    setApprovalActiveStep(data.purchaseRequest.approvalProcess.level);
    setCanBeEdit(data.canBeEdit);
  }

  async function getApprovalProcessData(purchaseRequestID = 0) {
    const response = await getDocumentApprovalProcess(
      "PORQ",
      purchaseRequestID
    );
    const { data } = response.data;
    setApprovalProcess(data.approvalProcess);
  }
}

export default PrBasicInfo;
